export const DUPLICATE_TEMPLATE = 'DUPLICATE_TEMPLATE';
export const FETCH_TEMPLATES = 'FETCH_TEMPLATES';
export const FETCH_EVERY_TEMPLATES = 'FETCH_EVERY_TEMPLATES';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const SET_EVERY_TEMPLATE = 'SET_EVERY_TEMPLATE';
export const GET_TEMPLATE_INFO = 'GET_TEMPLATE_INFO';
export const SET_TEMPLATE_INFO = 'SET_TEMPLATE_INFO';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
export const ADD_SUCCESS = 'ADD_SUCCESS';
export const FETCH_SEARCH = 'FETCH_SEARCH';
export const SET_SEARCH = 'SET_SEARCH';
export const FETCH_COUNTER = 'FETCH_COUNTER';
export const SET_COUNTER = 'SET_COUNTER';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const UPDATE_TEMPLATES = 'UPDATE_TEMPLATES';